import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IDocUserMap } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class DocUserMapService extends BaseService<IDocUserMap> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'docUserMap');
  }
}

export { IDocUserMap } from '../shared/api';
